/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { isFalse, isTrue } from "utils/empty-exists";

const AsList = (props) => {

    const { asList, children } = props || {};

    return (
        <Fragment>
            {isTrue(asList) &&
            <li className='as-list'>{children}</li>
            }
            {isFalse(asList) &&
            <>{children}</>
            }
        </Fragment>
    );
};

export { AsList };
